import styled from "styled-components";

interface IContainer {
  disable: boolean;
  hideSearch?: boolean;
  maxHeight?: number;
}
export const Container = styled.div<IContainer>`
  opacity: ${({ disable }) => (disable ? 0.2 : 1)};
  pointer-events: ${({ disable }) => (disable ? "none" : "auto")};
`;
